import { AppAccountSettingRepository } from "@/domain/repository/app-account-setting-repository";
import { AccountSetupIdentityEntity } from "@/domain/entity/app-account-setting/account-setup-identity-entity";
import { SATError, SATResult } from "@sadtx/sat-error";

export class CheckUserNameBySmsTokenForLoginAccountUsecase {
  constructor(private readonly appAccountSettingRepo: AppAccountSettingRepository) {}

  async execute(name: string): Promise<SATResult<AccountSetupIdentityEntity, SATError>> {
    return this.appAccountSettingRepo.checkUserNameBySmsTokenForLoginAccount(name);
  }
}
